import styles from "../../../styles/home/banner/banner.module.css";
import StaggerContainer from "../StaggerContainer/StaggerContainer";

export default function Banner() {
  return (
    <main className={styles.hero}>
      <StaggerContainer className={styles.heroContent} staggerDelay={0.15}>
        <h2 className={styles.bannerHeading}>
          Diagnomed - The Official Distribution Partner of ANCHOR Diagnostics in India
        </h2>
        <p className={styles.bannerText}>
          Bringing German-engineered molecular diagnostic technologies to Indian laboratories with trusted local expertise, nationwide support, and a commitment to scientific excellence.
        </p>
      </StaggerContainer>
    </main>
  );
}
